<template>
  <div class="certExpiredDetails">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="infoForm"
        label-position="rigth"
        label-width="100px"
        ref="infoForm"
        :rules="infoFormRule"
      >
        <!-- <div class="form-item-wrap">
          <el-form-item label="机构编号" prop="endId">
            <el-input v-model="infoForm.endId" style="width:300px;" readonly></el-input>
          </el-form-item>
          <el-form-item label="单位名称" prop="business">
            <el-input v-model="infoForm.business" style="width:300px;" readonly></el-input>
          </el-form-item>
        </div> -->
        <!-- <div class="form-item-wrap">
          <el-form-item label="客户类型" prop="type">
            <el-input v-model="infoForm.type" style="width:300px;" readonly></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="infoForm.name" style="width:300px;" readonly></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="ERP编号" prop="erpId">
            <el-input v-model="infoForm.erpId" style="width:300px;" readonly @click.native="getErpCode"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
             <el-input v-model="infoForm.email" style="width:300px;" readonly></el-input>
          </el-form-item>
        </div> -->
        <!-- <div class="form-item-wrap">
          <el-form-item label="手机" prop="tel">
            <el-input v-model="infoForm.tel" style="width:300px;"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-input v-model="infoForm.sex" style="width:300px;" readonly></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="生日" prop="birthday">
            <el-input v-model="infoForm.birthday" style="width:300px;" readonly></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="infoForm.address" style="width:300px;" readonly></el-input>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="资格证书">
            <el-table
              :data="seniorityList"
              tooltip-effect="dark"
              style="
                width: 700px;
                border: 1px solid #ebeef5;
                border-bottom: none;
              "
            >
              <el-table-column label="序号" align="center" width="50">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                show-overflow-tooltip
                prop="name"
                label="名称"
              >
              </el-table-column>
              <el-table-column
                align="center"
                show-overflow-tooltip
                prop="img"
                label="证书"
              >
                <template slot-scope="scope">
                  <img-view
                    :imgList="[{ url: scope.row.img, id: 0 }]"
                  ></img-view>
                </template>
              </el-table-column>
              <el-table-column prop="validity" label="更新时间" align="center">
              </el-table-column>
            </el-table>
          </el-form-item>
        </div>
        <!-- <div class="form-item-wrap">
          <el-form-item label="经营范围" prop="range">
            <div style="width: 800px;">
              <div>
                <el-tag 
                  v-for="(item,index) in rangeList" 
                  :key="index" 
                  closable
                  @close="tagClose(index)"
                  type="success"
                  effect="dark"
                  :disable-transitions="false"
                  class="my-el-tag"
                  style="margin-bottom: 5px;">{{item}}
                </el-tag>
              </div>
              <el-button type="primary" @click="getTableData">增加经营范围</el-button>
            </div>
          </el-form-item>
        </div> -->
        <!-- <div class="form-item-wrap">
          <el-form-item label="回执意见" prop="des">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              style="width:700px;"
              rows="5"
              v-model="infoForm.des">
            </el-input>
          </el-form-item>
        </div> -->
        <!-- <div class="form-item-wrap">
          <el-form-item label="">
            <el-button type="primary" @click="submit(2)">通过</el-button>
            <el-button type="info" @click="submit(0)">拒绝</el-button>
          </el-form-item>
        </div> -->
      </el-form>
    </el-scrollbar>

    <!-- 数据选择 -->
    <tableDialog
      v-if="dialogVisible"
      :title="'经营范围'"
      :isMoreSel="true"
      :searchValue="searchForm.name"
      :tableData="tableList"
      :tableHead="tableDataHead"
      :currPage.sync="currPage"
      :allPage="allPage"
      @search="getTableData"
      @rowClick="rowClick"
      @moreSel="selDataOk"
      @hanCurrChange="hanCurrChange"
      @close="dialogVisible = false"
    ></tableDialog>

    <!-- 数据选择 -->
    <tableDialog
      v-if="isErpCode"
      :title="'ERP编号'"
      :searchValue="searchFormErp.name"
      :tableData="erpCodeList"
      :tableHead="erpCodeHead"
      :currPage.sync="currPageErp"
      :allPage="allPageErp"
      :tips="erpCodeTips"
      @search="getErpCode"
      @rowClick="setErpCode"
      @close="isErpCode = false"
    ></tableDialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "certExpiredDetails",
  data() {
    return {
      /**基本信息表单 */
      infoForm: {
        endId: "", // 机构ID
        business: "", // 单位名称
        type: "", // 客户类型
        name: "", // 姓名
        erpId: "", // erp编号
        tel: "", // 手机
        sex: "", // 性别
        birthday: "", // 生日
        email: "", // 邮箱
        address: "", // 地址
        range: "", // 经营范围
        des: "", // 回执意见
      },
      userId: "",
      infoFormRule: {
        erpId: [mustFill],
        tel: [mustFill],
        // range: [mustFill],
        des: [mustFill],
      },
      seniorityList: [],
      rangeList: [],
      dialogVisible: false,
      currPage: 1,
      allPage: 0,
      isSelDataOkRep: false,
      searchForm: {
        name: "",
      },
      tableList: [],
      tableDataHead: {},
      // erp编号列表
      isErpCode: false,
      currPageErp: 1,
      allPageErp: 0,
      searchFormErp: {
        name: "",
      },
      erpCodeList: [],
      erpCodeHead: {},
      erpCodeTips: "",
    };
  },
  mounted() {
    //接收role传递参数
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams.id) {
      this.userId = prams.id;
      this.getDetailed();
    }
  },
  methods: {
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    // getDetailed() {
    //   let data = {
    //     userId: this.userId,
    //   };
    //   this.$request({
    //     method: "post",
    //     url: "/Management/MemberAdmin/GetMemberRegistDetail",
    //     data: data,
    //   })
    //     .then((res) => {
    //       console.log(res, "数据");
    //       if (res.success) {
    //         let data = res.dataModel;
    //         this.infoForm.endId = data.EntId;
    //         this.infoForm.business = data.BusinessName;
    //         this.infoForm.type = data.ClinetType;
    //         this.infoForm.name = data.MemberName;
    //         this.infoForm.tel = data.Telphone;
    //         // this.infoForm.sex = data.sex
    //         // this.infoForm.birthday = data.birthday
    //         // this.infoForm.email = data.email
    //         this.infoForm.addressData = data.AreaCode;

    //         this.infoForm.Province = data.Province;
    //         this.infoForm.City = data.City;
    //         this.infoForm.Prefecture = data.Prefecture;
    //         this.infoForm.address = data.Address;
    //         this.seniorityList = data.Material || [];
    //         // this.erpCodeTips = `单位名称：${this.infoForm.business}，手机号：${this.infoForm.tel}，地址：${this.infoForm.address}`
    //         // this.searchFormErp.name = this.infoForm.business
    //       } else {
    //         this.$message({
    //           message: res.message,
    //           type: "error",
    //         });
    //       }
    //     })
    //     .catch((err) => {
    //       window.console.log(err);
    //     });
    // },
    getDetailed() {
      let data = {
        userId: this.userId,
      };
      this.$request({
        method: "post",
        url: "Member/GetMemberMaterial",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.seniorityList = (res.list || []).map((item) => ({
              name: item.MaterialName,
              img: item.MaterialUrl,
              validity: item.Lastmodifytime,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取erp编号列表
    getErpCode(val, isRep) {
      this.searchFormErp.name = isRep ? val : this.searchFormErp.name;
      let data = {
        memberId: this.userId,
        searchStr: this.searchFormErp.name,
        pageIndex: this.currPageErp,
        pageSize: 10,
      };
      this.$request({
        method: "post",
        url: "Member/AuditGetClientInfo",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.erpCodeList = res.list || [];
            this.erpCodeHead = {
              businessid: "ERP编号",
              businessname: "单位名称",
              telephone: "手机号",
              address: "地址",
            };
            this.allPageErp = res.toTal;
            this.isErpCode = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 选择erp编号
    setErpCode(row) {
      if (row) {
        this.infoForm.erpId = row.businessid;
        this.isErpCode = false;
      }
    },
    // 获取弹出框表格数据
    getTableData(val, isRep) {
      this.searchForm.name = isRep ? val : this.searchForm.name;
      let data = {
        entId: window.localStorage.getItem("entId"),
        pageIndex: this.currPage,
        pageSize: 10,
        sqlValue: this.searchForm.name,
        channel_id: 12,
        keyId: 0,
      };
      this.$request({
        method: "post",
        url: "Base/GetTableCategory",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.tableList = res.list;
            this.tableDataHead = {
              Id: "编号",
              entId: "机构编号",
              title: "名称",
              sort_id: "排序",
            };
            this.allPage = res.toTal;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    // 选择单条数据
    rowClick(row, isSelDataOk) {
      for (let i = 0; i < this.rangeList.length; i++) {
        if (this.rangeList[i] == row.title) {
          if (isSelDataOk === true) {
            this.isSelDataOkRep = true;
          } else {
            this.$message({
              message: "选择的数据已在列表中",
              type: "warning",
            });
          }
          return;
        }
      }
      this.rangeList.push(row.title);
      this.infoForm.range = this.rangeList.join();
      this.dialogVisible = false;
    },
    // 选择数据完成，多选
    selDataOk(selectedList) {
      if (selectedList.length == 0) {
        this.$message({
          message: "请选择数据",
          type: "warning",
        });
        return;
      }
      selectedList.forEach((item) => {
        this.rowClick(item, true);
      });
      if (this.isSelDataOkRep) {
        this.$message({
          message: "选择的数据已在列表中",
          type: "warning",
        });
        this.isSelDataOkRep = false;
      }
    },
    // 标签删除
    tagClose(index) {
      this.rangeList.splice(index, 1);
      this.infoForm.range = this.rangeList.join();
    },
    /**提交表单 */
    submit(status) {
      let tips = "请确认信息，是否确认通过审核";
      let type = "success";
      if (status == 2) {
        tips = "请确认信息，是否确认通过审核";
        type = "success";
      } else if (status == 0) {
        tips = "是否拒绝通过审核";
        type = "warning";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          if (status == 2) {
            this.testForm(status);
          } else if (status == 0) {
            this.submitForm(status);
          }
        })
        .catch(() => {});
    },
    // 验证表单信息
    testForm(status) {
      this.$refs["infoForm"].validate((valid) => {
        if (valid) {
          this.submitForm(status);
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    // 提交表单信息
    submitForm(status) {
      let data = {
        userId: this.userId,
        status: status,
        telphone: this.infoForm.tel,
        erpcode: this.infoForm.erpId,
        remark: this.infoForm.des,
        // businesscont: this.infoForm.range
        businesscont: "",
      };
      this.$request({
        method: "post",
        url: "Member/MemberRegistAudit",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.goBack();
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
            if (status == 0) {
              this.goBack();
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.certExpiredDetails {
  width: 100%;
  height: 100%;
}
</style>
